module.exports = __webpack_public_path__ + "assets/img/one-1.0befd457.svg";